import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const UwcLogo = ({
  width = 741.49,
  height = 280.77,
  fill = colors.light,
  responsive = true,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 522 172"
      aria-labelledby="uwcLogoTitle"
      focusable="false"
      role="img"
      {...svgAttributes}
    >
      <title id="uwcLogoTitle">Ultimate World Cruise 2023/2024</title>
      <g clip-path="url(#clip0_2_2)">
        <path
          d="M261.4 1.52737e-06C263.4 2 265.7 4 267.7 6.1L265.4 9.1V9.2L271.5 11.9L275.6 9.1L273 6.3V6.1C275.5 4.3 277.7 2.6 280.2 0.900002L279 13.3H243.5L242.3 1C244.8 2.7 246.9 4.4 249.5 6.2V6.4L247 9.2L251.1 12L257.2 9.3V9L254.9 6C256.9 4 259.1 1.9 261.2 -0.0999985H261.4V1.52737e-06Z"
          fill={fill}
        />
        <path
          d="M278.7 15.5L278.3 19.6H265.2V33.8H271.6C273 33.8 274.5 32.3 274.2 31.3C273.9 29.9 272.6 28.9 271.4 28.2C271.6 28.2 276 25 278.1 23.6C278 24.5 276.5 36.1 276.5 36.3L261.4 42H261.2L246 36.2C246 36 244.5 24.4 244.4 23.5C246.5 24.9 250.8 28.1 251.1 28.1C249.9 28.8 248.6 29.8 248.3 31.2C248 32.2 249.5 33.7 250.9 33.7H257.3V19.5H244.2L243.8 15.4H278.7V15.5Z"
          fill={fill}
        />
        <path
          d="M184.4 27.2V29.8H174V28C178.6 23.4 181 20.5 181 18.5C181 17.1 180.3 16.3 178.9 16.3C177.4 16.3 176.4 16.7 175.2 17.4L174.1 15.4C175.4 14.5 177 13.7 179 13.7C182.4 13.7 184 15.5 184 18.3C184 20.9 182.5 23.1 178.7 27H184.4V27.2Z"
          fill={fill}
        />
        <path
          d="M194.7 13.8C197.8 13.8 199.9 15.7 199.9 18.8V25C199.9 28.1 197.8 30 194.7 30C191.6 30 189.5 28.1 189.5 25V18.8C189.6 15.7 191.7 13.8 194.7 13.8ZM194.7 27.5C196.1 27.5 197 26.6 197 24.8V19.1C197 17.3 196.1 16.4 194.7 16.4C193.4 16.4 192.5 17.3 192.5 19.1V24.8C192.5 26.6 193.4 27.5 194.7 27.5Z"
          fill={fill}
        />
        <path
          d="M215.8 27.2V29.8H205.4V28C210 23.4 212.4 20.5 212.4 18.5C212.4 17.1 211.7 16.3 210.3 16.3C208.8 16.3 207.8 16.7 206.6 17.4L205.5 15.4C206.8 14.5 208.4 13.7 210.4 13.7C213.8 13.7 215.4 15.5 215.4 18.3C215.4 20.9 213.9 23.1 210.1 27H215.8V27.2Z"
          fill={fill}
        />
        <path
          d="M231 24.9V25.3C231 28 229.2 30.1 225.8 30.1C223.8 30.1 222.2 29.5 220.9 28.6L221.9 26.5C223.1 27.1 224.1 27.6 225.6 27.6C227.1 27.6 228 26.7 228 25.3C228 23.6 227.2 22.8 225.6 22.8H224V20.6H225.8C227.2 20.6 227.9 19.8 227.9 18.5C227.9 17.3 227.3 16.5 225.9 16.5C224.4 16.5 223.3 16.8 222.1 17.3L221.3 15.3C222.7 14.5 224.1 13.9 226.1 13.9C229.4 13.9 230.8 15.9 230.8 18.3C230.8 19.4 230.4 20.6 229.3 21.5C230.2 22 231 23.7 231 24.9Z"
          fill={fill}
        />
        <path
          d="M300.4 27.2V29.8H290V28C294.6 23.4 297 20.5 297 18.5C297 17.1 296.3 16.3 294.9 16.3C293.4 16.3 292.4 16.7 291.2 17.4L290.1 15.4C291.4 14.5 293 13.7 295 13.7C298.4 13.7 300 15.5 300 18.3C300 20.9 298.5 23.1 294.7 27H300.4V27.2Z"
          fill={fill}
        />
        <path
          d="M310.7 13.8C313.8 13.8 315.9 15.7 315.9 18.8V25C315.9 28.1 313.8 30 310.7 30C307.6 30 305.5 28.1 305.5 25V18.8C305.6 15.7 307.7 13.8 310.7 13.8ZM310.7 27.5C312.1 27.5 313 26.6 313 24.8V19.1C313 17.3 312.1 16.4 310.7 16.4C309.4 16.4 308.5 17.3 308.5 19.1V24.8C308.5 26.6 309.4 27.5 310.7 27.5Z"
          fill={fill}
        />
        <path
          d="M331.8 27.2V29.8H321.4V28C326 23.4 328.4 20.5 328.4 18.5C328.4 17.1 327.7 16.3 326.3 16.3C324.8 16.3 323.8 16.7 322.6 17.4L321.5 15.4C322.8 14.5 324.4 13.7 326.4 13.7C329.8 13.7 331.4 15.5 331.4 18.3C331.4 20.9 329.9 23.1 326.1 27H331.8V27.2Z"
          fill={fill}
        />
        <path
          d="M347.2 24.3V26.9H345.8V29.7H342.9V26.9H335.6V25.2L340.8 14.1H343.9L339.1 24.3H342.9V19H345.8V24.3H347.2Z"
          fill={fill}
        />
        <path
          d="M43.1 93.7L51 127.2L58.3 93.7H66.5L73.9 127.1L81.9 93.7H90.5L77.9 137.6H69.8L62.3 105.4L55 137.6H46.9L34.3 93.7H43.1Z"
          fill={fill}
        />
        <path
          d="M113.5 92.8C122.3 92.8 129.4 98.3 129.4 107.1V124.1C129.4 133 122.2 138.5 113.5 138.5C104.8 138.5 97.6 133 97.6 124.1V107.1C97.5 98.3 104.7 92.8 113.5 92.8ZM113.5 131.1C117.6 131.1 121 128.5 121 123.4V107.9C121 102.9 117.6 100.2 113.5 100.2C109.4 100.2 106 102.9 106 107.9V123.4C105.9 128.5 109.3 131.1 113.5 131.1Z"
          fill={fill}
        />
        <path
          d="M148.2 120.9V137.7H139.9V93.7H156C164.9 93.7 170.6 99.2 170.6 106.6V108.7C170.6 114.1 167.5 118.6 162.3 120.4L167.1 129.4C168.6 132.2 171.2 131.9 173.1 131.4L173 137.8C165.8 138.9 162.1 138.4 158.6 131.3L153.7 121.5C151.9 121.6 149.9 121.4 148.2 120.9ZM155.6 114.3C160 114.3 162.2 111.5 162.2 108V107.4C162.2 103.8 160 101.2 156 101.2H148.2V113.6C150.5 114.1 152.9 114.3 155.6 114.3Z"
          fill={fill}
        />
        <path d="M191.3 93.7V130.3H209V137.6H183V93.7H191.3Z" fill={fill} />
        <path
          d="M233.3 93.7C242.3 93.7 247.8 99.3 247.8 108V123.3C247.8 132 242.3 137.6 232.6 137.6C227 137.6 221.7 136.8 217.2 135.2V93.7H233.3ZM232.6 130.3C237.2 130.3 239.4 127.5 239.4 122.5V108.7C239.4 103.7 237.2 101 233.2 101H225.4V129.4C228.1 130.2 230 130.3 232.6 130.3Z"
          fill={fill}
        />
        <path
          d="M291.3 138.5C282.5 138.5 276.1 132.9 276.1 124.2V107.1C276.1 98.4 282.6 92.8 291.3 92.8C296.9 92.8 300.3 94.4 304 97L300.8 102.9C297.6 101.1 295.5 100.1 291.3 100.1C287.2 100.1 284.5 103 284.5 107.8V123.3C284.5 128.3 287.3 131.1 291.3 131.1C295.5 131.1 297.6 130.1 300.8 128.3L304 134.2C300.2 136.9 296.8 138.5 291.3 138.5Z"
          fill={fill}
        />
        <path
          d="M322.6 120.9V137.7H314.3V93.7H330.4C339.3 93.7 345 99.2 345 106.6V108.7C345 114.1 341.9 118.6 336.7 120.4L341.5 129.4C343 132.2 345.6 131.9 347.5 131.4L347.4 137.8C340.2 138.9 336.5 138.4 333 131.3L328.1 121.5C326.2 121.6 324.3 121.4 322.6 120.9ZM329.9 114.3C334.3 114.3 336.5 111.5 336.5 108V107.4C336.5 103.8 334.3 101.2 330.3 101.2H322.5V113.6C324.8 114.1 327.2 114.3 329.9 114.3Z"
          fill={fill}
        />
        <path
          d="M386.5 93.7L386.4 137.6H378.6L378 134.5C375.8 136.7 372.4 138.5 368.3 138.5C359.5 138.5 355.9 133.7 355.9 124.9V93.7H364.4V124C364.4 129.1 366.2 131.3 370.4 131.3C373.8 131.3 376.7 129.3 378.2 127V93.7H386.5Z"
          fill={fill}
        />
        <path d="M408.1 93.7V137.6H399.8V93.7H408.1Z" fill={fill} />
        <path
          d="M432.9 131C438 131 441.1 128.7 441.1 125.4C441.1 121.8 438.6 120.1 433 119.3C425.6 118.2 420 114.7 420 105.8C420 98.3 425.1 92.9 434.3 92.9C440 92.9 443.8 94.5 447.7 97.2L444.4 103.2C441.1 101.4 438.4 100.2 434.4 100.2C430 100.2 428.1 102.5 428.1 105.5C428.1 109.7 431.1 110.9 435.8 111.6C442.7 112.6 449.4 115.6 449.4 124.7C449.4 132.5 444.2 138.4 433.3 138.4C427.5 138.4 422.5 136.6 418.7 133.9L422 127.7C425.2 129.7 428.8 131 432.9 131Z"
          fill={fill}
        />
        <path
          d="M486.6 93.7V101.1H468.8V111.6H483.7V118.9H468.8V130.3H487V137.6H460.5V93.7H486.6Z"
          fill={fill}
        />
        <path
          d="M171.3 54V76.3H168.3L168 74.5C166.9 75.7 165 76.8 162.7 76.8C158.4 76.8 156.4 74.6 156.4 70.1V54H159.7V69.6C159.7 72.5 160.8 73.8 163.3 73.8C165.3 73.8 167.1 72.5 167.9 71.3V54H171.3Z"
          fill={fill}
        />
        <path d="M200.7 73.3V76.3H187.8V54H191.1V73.3H200.7Z" fill={fill} />
        <path
          d="M225.7 57H219.8V76.3H216.5V57H210.6V54H225.7V57Z"
          fill={fill}
        />
        <path d="M243.9 54V76.3H240.6V54H243.9Z" fill={fill} />
        <path
          d="M278.7 54V76.3H275.4L275.5 62L270.4 72.2H268.6L263.6 62.3L263.7 76.4H260.4V54H262.9L269.6 67.3L276.3 54H278.7Z"
          fill={fill}
        />
        <path
          d="M312 76.3H308.3L306.5 70.3C304 70.7 301.5 70.7 299.1 70.3L297.3 76.3H293.7L301.3 54H304.5L312 76.3ZM305.7 67.6L302.7 58L299.8 67.6C301.7 68 303.7 68 305.7 67.6Z"
          fill={fill}
        />
        <path d="M337 57H331.1V76.3H327.8V57H322V54H337V57Z" fill={fill} />
        <path
          d="M364.9 73.3V76.3H351.9V54H364.7V57H355.2V63.4H363.1V66.4H355.2V73.3H364.9Z"
          fill={fill}
        />
        <path
          d="M6.50001 168.6V171.2H-0.499994V168.6H1.70001V159L-0.0999939 160.1L-1.39999 158L2.00001 155.5H4.50001V168.5H6.50001V168.6Z"
          fill={fill}
        />
        <path
          d="M20.4 166.2V166.9C20.4 170 18.3 171.6 15.2 171.6C12.2 171.6 9.90001 170.1 9.90001 167V160.3C9.90001 157.2 12 155.3 15.1 155.3C17.1 155.3 18.8 156 20.1 157L19 159C17.8 158.4 16.8 157.9 15.3 157.9C13.7 157.9 12.8 158.9 12.8 160.6V162.5C13.5 162.1 14.7 161.8 15.7 161.8C18.2 161.7 20.4 162.9 20.4 166.2ZM17.5 166.5C17.5 164.9 16.8 164.2 15.4 164.2C14.4 164.2 13.5 164.5 12.9 164.9V166.6C12.9 168.3 13.8 168.9 15.2 168.9C16.6 168.9 17.5 168.3 17.5 166.5Z"
          fill={fill}
        />
        <path
          d="M36.6 168.9C38.4 168.9 39.5 168.1 39.5 166.9C39.5 165.6 38.6 165 36.6 164.7C34 164.3 32 163.1 32 159.9C32 157.2 33.8 155.3 37.1 155.3C39.1 155.3 40.5 155.9 41.9 156.8L40.7 158.9C39.5 158.3 38.6 157.8 37.1 157.8C35.5 157.8 34.9 158.6 34.9 159.7C34.9 161.2 36 161.6 37.6 161.9C40.1 162.3 42.4 163.3 42.4 166.6C42.4 169.4 40.5 171.5 36.7 171.5C34.6 171.5 32.9 170.9 31.5 169.9L32.7 167.7C33.9 168.4 35.1 168.9 36.6 168.9Z"
          fill={fill}
        />
        <path
          d="M58.6 171.2H55.3L54.2 167.5C52.6 167.8 51 167.8 49.4 167.5L48.4 171.2H45.1L50.5 155.6H53.2L58.6 171.2ZM53.6 165.2L51.9 159.2L50.1 165.2C51.2 165.5 52.4 165.5 53.6 165.2Z"
          fill={fill}
        />
        <path d="M64.6 155.6V171.2H61.6V155.6H64.6Z" fill={fill} />
        <path d="M78.1 168.6V171.2H68.9V155.6H71.9V168.6H78.1Z" fill={fill} />
        <path d="M84.5 155.6V171.2H81.5V155.6H84.5Z" fill={fill} />
        <path
          d="M100 155.6V171.2H97.3L91.6 161.6L91.7 171.2H88.8V155.6H91.5L97.2 165.3L97.1 155.6H100Z"
          fill={fill}
        />
        <path
          d="M115.3 162.7V171.5H113.1L112.7 170.1C111.8 171 110.4 171.6 109 171.6C105.9 171.6 104.3 169.7 104.3 166.6V160.5C104.3 157.4 106.6 155.4 109.9 155.4C112.3 155.4 113.7 156 115.1 157.1L114 159.2C112.8 158.5 111.9 158.1 110 158.1C108.5 158.1 107.4 159.1 107.4 160.8V166.4C107.4 168.2 108.2 169.1 109.7 169.1C110.8 169.1 111.8 168.5 112.4 167.8V165.4H109.5V162.9H115.3V162.7Z"
          fill={fill}
        />
        <path
          d="M124.4 168.9C126.2 168.9 127.3 168.1 127.3 166.9C127.3 165.6 126.4 165 124.4 164.7C121.8 164.3 119.8 163.1 119.8 159.9C119.8 157.2 121.6 155.3 124.9 155.3C126.9 155.3 128.3 155.9 129.7 156.8L128.5 158.9C127.3 158.3 126.4 157.8 124.9 157.8C123.3 157.8 122.7 158.6 122.7 159.7C122.7 161.2 123.8 161.6 125.4 161.9C127.9 162.3 130.2 163.3 130.2 166.6C130.2 169.4 128.3 171.5 124.5 171.5C122.4 171.5 120.7 170.9 119.3 169.9L120.5 167.7C121.7 168.4 123 168.9 124.4 168.9Z"
          fill={fill}
        />
        <path
          d="M141.1 164C141.1 161.4 142.5 160.1 144.6 160.1C146.8 160.1 148.3 161.3 148.3 164C148.3 166.5 146.8 167.8 144.6 167.8C142.5 167.8 141.1 166.6 141.1 164Z"
          fill={fill}
        />
        <path
          d="M170.6 165.8V168.4H169.2V171.2H166.3V168.4H159V166.7L164.2 155.6H167.3L162.5 165.8H166.3V160.5H169.2V165.8H170.6Z"
          fill={fill}
        />
        <path
          d="M186.1 168.9C187.9 168.9 189 168.1 189 166.9C189 165.6 188.1 165 186.1 164.7C183.5 164.3 181.5 163.1 181.5 159.9C181.5 157.2 183.3 155.3 186.6 155.3C188.6 155.3 190 155.9 191.4 156.8L190.2 158.9C189 158.3 188.1 157.8 186.6 157.8C185 157.8 184.4 158.6 184.4 159.7C184.4 161.2 185.5 161.6 187.1 161.9C189.6 162.3 191.9 163.3 191.9 166.6C191.9 169.4 190 171.5 186.2 171.5C184.1 171.5 182.4 170.9 181 169.9L182.2 167.7C183.3 168.4 184.6 168.9 186.1 168.9Z"
          fill={fill}
        />
        <path
          d="M205.3 168.6V171.2H195.9V155.6H205.2V158.2H198.9V162H204.2V164.6H198.9V168.6H205.3Z"
          fill={fill}
        />
        <path
          d="M220 162.7V171.5H217.8L217.4 170.1C216.5 171 215.1 171.6 213.7 171.6C210.6 171.6 209 169.7 209 166.6V160.5C209 157.4 211.3 155.4 214.6 155.4C217 155.4 218.4 156 219.8 157.1L218.7 159.2C217.5 158.5 216.6 158.1 214.7 158.1C213.2 158.1 212.1 159.1 212.1 160.8V166.4C212.1 168.2 212.9 169.1 214.4 169.1C215.5 169.1 216.5 168.5 217.1 167.8V165.4H214.2V162.9H220V162.7Z"
          fill={fill}
        />
        <path
          d="M237.4 155.6V171.2H234.4L234.5 162.8L231.5 168.7H230L227.1 163.1L227.2 171.2H224.3V155.6H226.3L230.9 164.4L235.5 155.6H237.4Z"
          fill={fill}
        />
        <path
          d="M251.2 168.6V171.2H241.8V155.6H251.1V158.2H244.8V162H250.1V164.6H244.8V168.6H251.2Z"
          fill={fill}
        />
        <path
          d="M266.3 155.6V171.2H263.6L257.9 161.6L258 171.2H255V155.6H257.7L263.4 165.3L263.3 155.6H266.3Z"
          fill={fill}
        />
        <path
          d="M280.4 158.2H276.5V171.2H273.5V158.2H269.6V155.6H280.4V158.2Z"
          fill={fill}
        />
        <path
          d="M288.6 168.9C290.4 168.9 291.5 168.1 291.5 166.9C291.5 165.6 290.6 165 288.6 164.7C286 164.3 284 163.1 284 159.9C284 157.2 285.8 155.3 289.1 155.3C291.1 155.3 292.5 155.9 293.9 156.8L292.7 158.9C291.5 158.3 290.6 157.8 289.1 157.8C287.5 157.8 286.9 158.6 286.9 159.7C286.9 161.2 288 161.6 289.6 161.9C292.1 162.3 294.4 163.3 294.4 166.6C294.4 169.4 292.5 171.5 288.7 171.5C286.6 171.5 284.9 170.9 283.5 169.9L284.7 167.7C285.9 168.4 287.1 168.9 288.6 168.9Z"
          fill={fill}
        />
        <path
          d="M305.3 164C305.3 161.4 306.7 160.1 308.8 160.1C311 160.1 312.5 161.3 312.5 164C312.5 166.5 311 167.8 308.8 167.8C306.7 167.8 305.3 166.6 305.3 164Z"
          fill={fill}
        />
        <path
          d="M330.1 168.6V171.2H323.1V168.6H325.3V159L323.5 160.1L322.2 158L325.6 155.5H328.1V168.5H330.1V168.6Z"
          fill={fill}
        />
        <path
          d="M350.1 168.6V171.2H340.7V155.6H350V158.2H343.7V162H349V164.6H343.7V168.6H350.1Z"
          fill={fill}
        />
        <path
          d="M364.8 160.7V161.3C364.8 164.4 363 166.4 359.8 166.4H356.9V171.3H353.9V155.7H359.8C363 155.6 364.8 157.6 364.8 160.7ZM361.8 161C361.8 159.2 361 158.3 359.6 158.3H356.8V163.8H359.6C361 163.7 361.8 162.8 361.8 161Z"
          fill={fill}
        />
        <path d="M371.7 155.6V171.2H368.7V155.6H371.7Z" fill={fill} />
        <path
          d="M381.3 171.6C378.2 171.6 375.9 169.6 375.9 166.5V160.4C375.9 157.3 378.2 155.3 381.3 155.3C383.3 155.3 384.5 155.9 385.8 156.8L384.7 158.9C383.6 158.3 382.8 157.9 381.3 157.9C379.8 157.9 378.9 158.9 378.9 160.6V166.1C378.9 167.9 379.9 168.9 381.3 168.9C382.8 168.9 383.5 168.5 384.7 167.9L385.8 170C384.5 171 383.3 171.6 381.3 171.6Z"
          fill={fill}
        />
        <path
          d="M408.8 171.2H405.5L404.4 167.5C402.8 167.8 401.2 167.8 399.6 167.5L398.6 171.2H395.3L400.7 155.6H403.4L408.8 171.2ZM403.7 165.2L402 159.2L400.2 165.2C401.4 165.5 402.5 165.5 403.7 165.2Z"
          fill={fill}
        />
        <path
          d="M422.7 160.7V166.1C422.7 169.2 420.7 171.2 417.5 171.2H411.8V155.6H417.5C420.7 155.6 422.7 157.6 422.7 160.7ZM419.7 161C419.7 159.2 418.9 158.3 417.5 158.3H414.7V168.7H417.5C418.9 168.7 419.7 167.8 419.7 166V161Z"
          fill={fill}
        />
        <path
          d="M438.2 155.6L433 171.2H430.5L425.2 155.6H428.3L431.7 167.6L435 155.6H438.2Z"
          fill={fill}
        />
        <path
          d="M450.7 168.6V171.2H441.3V155.6H450.6V158.2H444.3V162H449.6V164.6H444.3V168.6H450.7Z"
          fill={fill}
        />
        <path
          d="M465.8 155.6V171.2H463.1L457.4 161.6L457.5 171.2H454.6V155.6H457.3L463 165.3L462.9 155.6H465.8Z"
          fill={fill}
        />
        <path
          d="M479.9 158.2H476V171.2H473V158.2H469.1V155.6H479.9V158.2Z"
          fill={fill}
        />
        <path
          d="M494 155.6V171.2H491.2L491 170.1C490.2 170.9 489 171.5 487.5 171.5C484.4 171.5 483.1 169.8 483.1 166.7V155.6H486.1V166.4C486.1 168.2 486.7 169 488.2 169C489.4 169 490.5 168.3 491 167.5V155.6H494Z"
          fill={fill}
        />
        <path
          d="M510.1 169V171.3C507.5 171.7 506.2 171.5 505 169L503.3 165.5C502.8 165.5 501.8 165.4 501.1 165.2V171.2H498.1V155.6H504.1C507.3 155.6 509.3 157.6 509.3 160.2V161C509.3 162.9 508.2 164.5 506.3 165.2L508 168.4C508.5 169.3 509.4 169.2 510.1 169ZM501 162.6C501.8 162.8 503 162.9 503.9 162.9C505.5 162.9 506.2 161.9 506.2 160.6V160.4C506.2 159.1 505.4 158.2 504 158.2H501V162.6Z"
          fill={fill}
        />
        <path
          d="M522.6 168.6V171.2H513.2V155.6H522.5V158.2H516.2V162H521.5V164.6H516.2V168.6H522.6Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2_2">
          <rect width="521.3" height="171.6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default UwcLogo
